
{
  "fr": {
    "configuratorLayerEditorModal": {
      "title": {
        "addImage": "Insérez une image",
        "editText": "Modifier mon texte",
        "cropImage": "Modifier l'image"
      }
    }
  }
}
